import Button from "common/Buttons/Button.tsx";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import CreatePersonalGroupModal from "features/bots/Groups/CreatePersonalGroupModal.tsx";
import React, { CSSProperties, useState } from "react";
import Link from "common/Typography/Link.tsx";
import styled, { useTheme } from "styled-components";
import { Plus } from "lucide-react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface CreatePersonalGroupButtonProps {
  isLink?: boolean;
  style?: CSSProperties;
  setModalOpen?: (open: boolean) => void;
}

const CreatePersonalGroupButton = ({
  isLink,
  setModalOpen: propsSetModalOpen,
  style,
}: CreatePersonalGroupButtonProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);

  const [modalOpen, setModalOpen] = useState(false);

  const openModal = propsSetModalOpen ?? setModalOpen;
  const props = {
    style,
    onClick: () => openModal(true),
  };

  const { isNewLook } = useTheme();
  const text = (
    <>
      {isNewLook ? (
        <Plus
          size={isLink ? 14 : 16}
          strokeWidth={1.75}
          style={{ marginRight: isLink ? 4 : 6, verticalAlign: -3 }}
        />
      ) : (
        <StyledPlusOutlined $isLink={isLink} />
      )}
      {t("buttons.create_group")}
    </>
  );

  return (
    <>
      {isLink ? (
        <Link {...props}>{text}</Link>
      ) : (
        <Button {...props}>{text}</Button>
      )}
      <CreatePersonalGroupModal
        open={modalOpen}
        closeModal={() => setModalOpen(false)}
      />
    </>
  );
};

export default CreatePersonalGroupButton;

const StyledPlusOutlined = styled(PlusOutlined)<{ $isLink?: boolean }>`
  margin-right: ${(p) => (p.$isLink ? 4 : 8)}px;
`;
